export default "__VITE_ASSET__c3d10d06__"